<template>
    <v-layout class="component-wrap">
        <FAQ />
    </v-layout>
</template>

<script>
import FAQ from '@/components/view_blocks/FAQ/FAQ_wrap';

export default {
  components: {
    FAQ,
  },
};
</script>

